import React, { useMemo } from 'react'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useQuery } from '@apollo/client'
import { Button } from '@dasa-health/components-react'
import { Carousel } from '@nsw-paginas-deslogadas/typings'
import { productsByIdsQuery } from '../../services/graphql/queries'
import { Container, Card, Title, ContainerCard, Exam, ExamPrice, ExamName, ExamList } from './styles'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { BrandId, BrandIdType } from '@nsw-paginas-deslogadas/constants/brands'
import { formatAsCurrency } from '@nsw-paginas-deslogadas/utils'

type PricePerBrand = {
    brandId: number
    price: number
}

type Product = {
    id: number
    name: string
    lowestPriceBrand: PricePerBrand[]
}

type ProductsQueryData = {
    productsByIds: Product[]
}

type ProductInfo = {
    name?: string
    price?: string
}

const CardExamV2: React.FC<Carousel> = ({ brandId, title, button, image, exams, brandMapping }) => {
    const { brand } = useAppContext()
    const map = BrandMapping[brand.mappingId]
    const productsId = exams.map(item => item.id)
    const { loading, data } = useQuery<ProductsQueryData>(productsByIdsQuery, {
        variables: { productsId },
    })
    const priceTextArray: BrandIdType[] = useMemo(() => [BrandId.Itulab, BrandId.Deliberato, BrandId.Leme, BrandId.OswaldoCruz], [])
    const showPriceText = useMemo(() => {
        return !priceTextArray.includes(brand.mappingId)
    }, [brand.mappingId, priceTextArray])

    const renderExamList = (products: Product[]) => {
        const result: ProductInfo[] = products.map(product => {
            const navId = brandId === 0 ? 2 : brandId
            const price = product.lowestPriceBrand.find(brand => brand.brandId === navId)?.price
            return {
                name: exams.find(exam => exam.id === product.id)?.name,
                price: price ? formatAsCurrency(price) : undefined,
            }
        })
        return result
    }

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'Carrossel',
        'data-current-service': 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <Container data-testid="ContainerTestID" style={{ backgroundColor: map.lpDesignProps?.swiper.cardColor }}>
            <ContainerCard data-testid="ContainerCardTestID">
                <img alt={image.alt} src={image.src} />
                <Card data-testid="CardTestID">
                    <ExamList data-testid="ExamListTestID">
                        <Title>{title.toString()}</Title>
                        {!loading &&
                            data &&
                            renderExamList(data.productsByIds).map(item => {
                                if ((showPriceText && !item.name) || (showPriceText && !item.price)) return null
                                return (
                                    <Exam data-testid="DescriptionTestID" key={item.name}>
                                        <ExamName>{item.name}</ExamName>
                                        {showPriceText ? (
                                            <ExamPrice>
                                                A partir de <span>{item.price}</span>
                                            </ExamPrice>
                                        ) : (
                                            <ExamPrice />
                                        )}
                                    </Exam>
                                )
                            })}
                    </ExamList>
                    <a
                        href={button.url}
                        {...dataAtributtes(button.text?.toString())}
                        style={{ textDecoration: 'none', width: '100%' }}
                    >
                        <Button
                            fullWidth
                            sx={{
                                width: '100%',
                                height: '48px',
                                fontSize: '16px',
                                fontFamily: 'Dasa Sans',
                                padding: '12px',
                                backgroundColor: map.lpDesignProps?.swiper.buttonBackgroundColor,
                                color: map.lpDesignProps?.swiper.buttonTextColor,
                                ':hover, :focus, :active': {
                                    backgroundColor: map.lpDesignProps?.swiper.buttonBackgroundColor,
                                    color: map.lpDesignProps?.swiper.buttonTextColor,
                                },
                            }}
                            variant="primary"
                        >
                            {button.text.toString()}
                        </Button>
                    </a>
                </Card>
            </ContainerCard>
        </Container>
    )
}
export default CardExamV2
